import {
  checkHttpStatus,
  getApiBaseUrlWithOrg,
  getApiHeadersFromToken
} from '../../../../utils/api'

export const fetchLevelDetails = async function (
  levelId,
  apiData,
  masterCourseId,
  courseId
) {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/master_courses/${masterCourseId}/courses/${courseId}/levels/${levelId}`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )

    return await response.json()
  } catch (e) {
    return null
  }
}

export const fetchLevelProgress = async function (
  levelId,
  apiData,
  courseSectionId,
  userId
) {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/users/${userId}/course_sections/${courseSectionId}/levels_progress/${levelId}`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )

    return await response.json()
  } catch (e) {
    return null
  }
}
